if (!customElements.get('boxed-scroll')) {
    class BoxedScroll extends HTMLElement {
  
        constructor() {
            super();
            this.isVisible = false;
            this.delay = this.dataset.delay;
            window.addEventListener('scroll', this.isInViewPort.bind(this), false);
        }
      
        isInViewPort(event) {
            var bounding = this.getBoundingClientRect();
            if (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
                bounding.top <= (window.innerHeight || document.documentElement.clientHeight)
            ) {
                if (this.isVisible == false) {
                    this.isVisible = true;
                    var self = this;
                    window.setTimeout(function() {
                        self.style.transform = "translateY(0px)";
                        self.style.opacity = "1";
                    }, this.delay * 250);
                }
            }
        }
    }
    
    customElements.define('boxed-scroll', BoxedScroll);
}